import {isInPaypalExperiment} from '../../../selectors/ExperimentSelectors';
import Track from '../../../utils/tracking';
import * as actionTypes from '../../action-types';
import * as CheckoutAPIActions from '../../APIActions/CheckoutAPIActions';

export const updateClientIdList = clientIdByPayment => ({
  type: actionTypes.UPDATE_CLIENT_ID_LIST,
  clientIdByPayment,
});

export default () => (dispatch, getState) => {
  const expressPaymentOptions = getState().start.paymentOptions.paymentOptions
    .filter(option => option.express).map(option => option.name);
  if (expressPaymentOptions.length > 0) {
    if (expressPaymentOptions.includes('PAYPAL') && isInPaypalExperiment(getState())) {
      dispatch(CheckoutAPIActions.getPaypalExpressClientId())
        .then((clientIdResponse) => {
          if (clientIdResponse?.msg) {
            dispatch(updateClientIdList({name: 'PAYPAL', clientId: clientIdResponse.msg.clientId}));
          }
        })
        .catch((error) => {
          Track.error(error);
        });
    }
  }
};
